import moment from 'moment'
import settings from '../config/settings';

const handleDateFormatField = (dimensions) => {
  let dateFormat = {};
  dimensions?.map(dim => {
    if (dim?.dateFormat) {
      dateFormat[dim?.fieldName + '_date'] = dim?.dateFormat
    }
    else if (dim?.timeFormat) {
      dateFormat[dim?.fieldName + `_${dim?.timeFormatType}`] = dim?.timeFormat
    }
    return dim
  })
  return dateFormat;

}

const handleMeasureFieldFormat = (measures) => {
  const formatObj = {}
  if (measures && measures.length) {
    measures.forEach(ele => {
      const { fieldName, fieldFormat } = ele;
      if (fieldFormat) {
        formatObj[fieldName] = fieldFormat;
      }
    })
  }
  return formatObj;
}

const handleQueryOrderBy = (report) => {
  let orderBy = {};
  if (report && report?.orderBy) {
    Object.entries(report?.orderBy).forEach(([k, v]) => {
      if (report?.dimensions.length) {
        let datasetName = report?.dimensions[0]?.fieldName.split('.')[0]
        orderBy[datasetName + '.' + k] = v
      } else {
        let datasetName = report?.measures[0]?.fieldName.split('.')[0]
        orderBy[datasetName + '.' + k] = v
      }
    })
  }
  return orderBy;
}


const getHiddenFields = (fields) => {
  let fieldsArr = []
  if (fields.length) {
    for (let field of fields) {
      if (field?.isHidden) {
        fieldsArr.push(field?.fieldName)
      }
    }
  }
  return fieldsArr;
}

const handleReportFields = (reportFields) => {
  let fieldsArr = []
  if (reportFields?.length) {
    for (let fields of reportFields) {
      // if(!fields?.isHidden) {
      fieldsArr.push(fields?.fieldName)
      // }
    }
  }
  return fieldsArr;
}



const handlePivotConfigFormat = (pivot) => {
  let xArr = pivot?.x
  let yArr = []

  if (pivot?.group?.length) {
    yArr = [...pivot?.group?.map(ele => ele.text), ...pivot?.y]
  }
  else {
    yArr = pivot?.y
  }

  let lines = pivot?.lines
  let group = pivot?.group

  const config = {
    x: xArr,
    y: yArr,
    lines,
    group,
  }

  return config
}

const handleColumnDisplayName = (report) => {
  const measures = report?.measures;
  const dimensions = report?.dimensions;
  const timeDimensions = report?.timeDimensions;
  const displayObj = {};


  if (measures && measures.length) {
    measures.forEach(ele => {
      const { fieldName, displayName } = ele;
      if (displayName) {
        displayObj[fieldName] = displayName;
      }
    })
  }

  if (dimensions && dimensions.length) {
    dimensions.forEach(ele => {
      const { fieldName, displayName } = ele;
      if (displayName) {
        displayObj[fieldName] = displayName;
      }
    })
  }

  if (timeDimensions && timeDimensions.length) {
    timeDimensions.forEach(ele => {
      const { dimension, displayTitle, displayName } = ele;
      if (displayName) {
        displayObj[dimension] = displayTitle ? displayTitle : displayName ? displayName : dimension
      }
    })
  }

  return displayObj;
}

const handleReportFilters = (filterData) => {
  if (filterData?.length) {
    let filters = filterData?.filter(f => (f && f?.member && f?.operator && ((f?.operator === 'set' || f?.operator === 'notSet') || (f?.values && f?.values?.length && !f?.values.includes(null)))))
    return filters.map(f => {
      if (f?.operator === "top" || f?.operator === "bottom") {
        f = { ...f, operator: "equals" }
      }
      if (f?.operator !== "set" && typeof f?.values[0] === 'number') {
        f.values = f?.values?.map(v => v?.toString())
      }
      return f;
    })
  }
  else {
    return filterData
  }
}


const formatStaticDashboardFilter = (reportFilter, reportDetailsQuery) => {
  let dataSetName = null;
  if (reportDetailsQuery.dimensions?.length > 0) {
    dataSetName = reportDetailsQuery.dimensions[0]?.fieldName?.split('.')[0];
  }
  else if (reportDetailsQuery.measures?.length > 0) {
    dataSetName = reportDetailsQuery.measures[0]?.fieldName?.split('.')[0];
  }
  else if (reportDetailsQuery.timeDimensions?.length > 0 && reportDetailsQuery.timeDimensions[0].dimension) {
    dataSetName = reportDetailsQuery.timeDimensions[0].dimension?.split('.')[0]
  }
  return reportFilter?.map(filter => {
    if ((filter?.filterType === 'profile_filter' || filter?.filterType === 'schoolCode_filter' || filter?.filterType === 'profileId_filter' || filter?.filterType === 'subject_filter' || filter?.filterType === 'date_filter') && filter?.member.split('.')[0] !== dataSetName) {
      filter.member = dataSetName + '.' + filter?.member.split('.')[1]
    }
    if (filter?.filterType === 'subject_filter') {
      filter.member = dataSetName + '.subject'
    }
    else if (filter?.filterType === 'date_filter' && (dataSetName === settings.ATTENDANCE_DATASET || dataSetName === settings.PROGRESS_REPORT_DATASET)) {
      filter.member = dataSetName + '.createDate'
    }
    else if (filter?.filterType === 'date_filter' && (dataSetName !== settings.PROGRESS_REPORT_DATASET || dataSetName !== settings.ATTENDANCE_DATASET)) {
      filter.member = dataSetName + '.dateTime'
    }
    if (filter?.operator !== "set" && typeof filter?.values[0] === 'number') {
      filter.values = filter?.values?.map(v => v?.toString())
    }
    return filter
  })
}


const generateFilterCol = (customId, query) => {
  const { measuresList } = query
  if (measuresList && measuresList?.length) {
    let key = customId?.studentId ? 'sUuid' : 'tUuid'
    const measure = measuresList.find(meas => (meas?.name.toLowerCase()).includes(key.toLowerCase()))
    if (measure) {
      return measure?.name
    }
    return ''
  }
  return ''
}

const formatStudentReportQuery = (customId, query) => { 
  let key = generateFilterCol(customId, query)
  if (customId && (customId?.studentId || customId?.teacherId) && query && key) {
    let dataSetName = null;
    if (query.dimensions?.length > 0) {
      dataSetName = query.dimensions[0]?.fieldName?.split('.')[0];
    }
    else if (query.measures?.length > 0) {
      dataSetName = query.measures[0]?.fieldName?.split('.')[0];
    }
    else if (query.timeDimensions?.length > 0 && query.timeDimensions[0].dimension) {
      dataSetName = query.timeDimensions[0].dimension?.split('.')[0]
    }
    if (query?.reportFilters?.length) {
      let ifExist = query?.reportFilters?.find(f => f?.member.includes(generateFilterCol(customId, query)))
      if (ifExist) {
        ifExist.values = [customId?.studentId ? customId?.studentId : customId?.teacherId]
      }
      else {
        query?.reportFilters.push({
          member: `${dataSetName}.${key}`,
          operator: 'equals',
          values: [customId?.studentId ? customId?.studentId : customId?.teacherId]
        })

      }
    }
    else {
      query?.reportFilters.push({
        member: `${dataSetName}.${key}`,
        operator: 'equals',
        values: [customId?.studentId ? customId?.studentId : customId?.teacherId]
      })

    }
    return query
  }
  return query
}

const handleFilterNullValues = (reportFilters) => {
  return reportFilters?.filter((item) => {
    if ((item.operator === 'set' || item.operator === 'notSet') || (item?.values?.length > 0 && !item?.values.includes(null) && !item?.values.includes(""))) {
      return item
    }
  })?.map(f => {
    if (f.operator === 'set' || f.operator === 'notSet') {
      return {
        member: f?.member, operator: f?.operator
      }
    } else {
      return {
        member: f?.member, operator: f?.operator, values: f?.values
      }
    }
  })
}



const getReportFieldsKey = (reportDetailsQuery) => {
  let info = { measureKey: [], dimensionKey: [] }
  if (reportDetailsQuery?.measures?.length) {
    info.measureKey = reportDetailsQuery?.measures.map(meas => meas?.fieldName)
  }
  if (reportDetailsQuery?.dimensions?.length) {
    info.dimensionKey = reportDetailsQuery?.dimensions.map(dim => dim?.fieldName)
  }
  return info
}

const handleRateChangeQuery = (reportDetailsQuery, renewCache) => {
  if ((reportDetailsQuery?.settings?.rateChangeProps?.periodicity || reportDetailsQuery?.settings?.rateChangeProps?.customVal)
    && (reportDetailsQuery?.timeDimensions?.length || reportDetailsQuery?.settings?.rateChangeProps?.dateField)) {
    const reportFilters = handleReportFilters(reportDetailsQuery?.reportFilters)
    const { periodicity, customVal } = reportDetailsQuery?.settings?.rateChangeProps
    let granularityDimension = reportDetailsQuery?.settings?.rateChangeProps?.dateField || reportDetailsQuery?.timeDimensions[0]?.dimension;
    const showYearOnYearChange = reportDetailsQuery?.settings?.rateChangeProps?.showYearOnYearChange || false;

    const queryProps = { chartType: reportDetailsQuery?.chartType, settings: reportDetailsQuery?.settings, query: [] }
    for (let i = 0; i < 2; i++) {
      let query = {
        measures: handleReportFields(reportDetailsQuery?.measures),
        order: handleQueryOrderBy(reportDetailsQuery?.orderBy),
        dimensions: handleReportFields(reportDetailsQuery?.dimensions),
        limit: reportDetailsQuery?.limit,
        timezone: 'UTC',
        timeDimensions: reportDetailsQuery?.timeDimensions,
        filters: handleFilterNullValues(reportFilters),
        renewQuery: renewCache
      }

      if (periodicity && !customVal) {
        switch (periodicity) {
          case 'daily':
            if (i === 0) {
              query.timeDimensions = [{ "dimension": granularityDimension, "dateRange": "Yesterday", "granularity": "day" }]
            }
            else {
              query.timeDimensions = [{ "dimension": granularityDimension, "dateRange": "Today", "granularity": "day" }]
            }
            break;
          case 'weekly':
            if (i === 0) {
              query.timeDimensions = [{ "dimension": granularityDimension, "dateRange": "Last Week", "granularity": "week" }]
            }
            else {
              query.timeDimensions = [{ "dimension": granularityDimension, "dateRange": "This Week", "granularity": "week" }]
            }
            break;
          case 'monthly':
            if (i === 0) {
              query.timeDimensions = [{ "dimension": granularityDimension, "dateRange": "Last Month", "granularity": "month" }]
            }
            else {
              query.timeDimensions = [{ "dimension": granularityDimension, "dateRange": "This Month", "granularity": "month" }]
            }
            break;

          case 'quarterly':
            if (i === 0) {
              query.timeDimensions = [{ "dimension": granularityDimension, "dateRange": "Last Quarter", "granularity": "quarter" }]

            }
            else {
              query.timeDimensions = [{ "dimension": granularityDimension, "dateRange": "This Quarter", "granularity": "quarter" }]
            }
            break;
          case 'yearly':
            if (i === 0) {
              query.timeDimensions = [{ "dimension": granularityDimension, "dateRange": "Last Year", "granularity": "year" }]
            }
            else {
              query.timeDimensions = [{ "dimension": granularityDimension, "dateRange": "This Year", "granularity": "year" }]
            }
            break;
          default:
            return
        }
      }
      else {
        let customVal = reportDetailsQuery?.settings?.rateChangeProps?.customVal
        customVal = parseInt(customVal)
        let granularity;
        if (customVal === 1) {
          granularity = 'day';
        }
        else if (customVal > 1 && customVal < 7) {
          granularity = 'weeek';
        }
        else if (customVal >= 7 && customVal < 30) {
          granularity = 'month';
        }
        else if (customVal >= 30 && customVal < 120) {
          granularity = 'quarter';
        }
        else {
          granularity = 'year';
        }

        let currEndDate = moment().format("YYYY/MM/DD");
        let currentStartDate = moment().subtract((customVal - 1), "days").format("YYYY/MM/DD");
        let prevEndDate = moment().subtract(customVal, "days").format("YYYY/MM/DD");
        let prevStartDate = moment().subtract(customVal, "days").subtract(customVal - 1, "days").format("YYYY/MM/DD");

        const startDate = new Date(new Date().getFullYear(), new Date().getMonth(), 1);

        if (new Date(prevStartDate) < startDate) {
          granularity = 'year'
        }
        else {
          granularity = 'month'
        }

        if (i === 0) {
          query.timeDimensions = [{ "dimension": granularityDimension, "dateRange": [prevStartDate, prevEndDate], "granularity": granularity }]
        }
        else {
          query.timeDimensions = [{ "dimension": granularityDimension, "dateRange": [currentStartDate, currEndDate], "granularity": granularity }]
        }
      }
      queryProps.query.push(query)
    }
    if (showYearOnYearChange) {
      const yoyQuery = {
        measures: handleReportFields(reportDetailsQuery?.measures),
        order: handleQueryOrderBy(reportDetailsQuery?.orderBy),
        dimensions: handleReportFields(reportDetailsQuery?.dimensions),
        limit: reportDetailsQuery?.limit,
        timezone: "UTC",
        timeDimensions: reportDetailsQuery?.timeDimensions,
        filters: handleFilterNullValues(reportFilters),
        renewQuery: reportDetailsQuery?.renewQuery,
      };
      if (periodicity && !customVal) {
        let start, end, granularity;

        switch (periodicity) {
          case "daily": {
            start = moment()
              .startOf("day")
              .subtract(1, "year")
              .format("YYYY-MM-DD");
            end = moment()
              .endOf("day")
              .subtract(1, "year")
              .format("YYYY-MM-DD");
            granularity = "day";
            break;
          }

          case "weekly": {
            start = moment()
              .startOf("week")
              .subtract(1, "year")
              .format("YYYY-MM-DD");
            end = moment()
              .endOf("week")
              .subtract(1, "year")
              .format("YYYY-MM-DD");
            granularity = "week";
            break;
          }

          case "monthly": {
            start = moment()
              .startOf("month")
              .subtract(1, "year")
              .format("YYYY-MM-DD");
            end = moment()
              .endOf("month")
              .subtract(1, "year")
              .format("YYYY-MM-DD");
            granularity = "month";
            break;
          }

          case "quarterly": {
            start = moment()
              .startOf("quarter")
              .subtract(1, "year")
              .format("YYYY-MM-DD");
            end = moment()
              .endOf("quarter")
              .subtract(1, "year")
              .format("YYYY-MM-DD");
            granularity = "quarter";
            break;
          }

          case "yearly": {
            start = moment()
              .startOf("year")
              .subtract(1, "year")
              .format("YYYY-MM-DD");
            end = moment()
              .endOf("year")
              .subtract(1, "year")
              .format("YYYY-MM-DD");
            granularity = "year";
            break;
          }

          default:
            return;
        }

        yoyQuery.timeDimensions = [
          {
            dimension: granularityDimension,
            dateRange: [start, end],
            granularity: granularity,
          },
        ];
      } else {
        let customVal =
          reportDetailsQuery?.settings?.rateChangeProps?.customVal;
        customVal = parseInt(customVal);
        let granularity;
        if (customVal === 1) {
          granularity = "day";
        } else if (customVal > 1 && customVal < 7) {
          granularity = "weeek";
        } else if (customVal >= 7 && customVal < 30) {
          granularity = "month";
        } else if (customVal >= 30 && customVal < 120) {
          granularity = "quarter";
        } else {
          granularity = "year";
        }

        let prevEndDate = moment()
          .subtract(1, "years")
          .format("YYYY/MM/DD");
        let prevStartDate = moment()
          .subtract(customVal - 1, "days")
          .subtract(1, "years")
          .format("YYYY/MM/DD");

        granularity =
          queryProps?.query[0]?.timeDimensions?.[0]?.granularity || granularity;
        yoyQuery.timeDimensions = [
          {
            dimension: granularityDimension,
            dateRange: [prevStartDate, prevEndDate],
            granularity: granularity,
          },
        ];
      }
      queryProps.query.push(yoyQuery);
    }
    return queryProps
  }
  return null
}


const formatReportTitle = (data) => {
  let dimensionTitle = {};
  let measureTitle = {};

  data?.dimensions?.map(dim => {
    let key = dim?.fieldName;
    dimensionTitle[key] = dim?.title
  })
  data?.measures?.map(meas => {
    let key = meas?.fieldName;
    measureTitle[key] = meas?.title
  });

  return [{ ...measureTitle, ...dimensionTitle }]
}


const MapResponseForQuery = (reportDetailsQuery, columnTitle, renewCache, isPublishedDashboardView, customId) => {
  reportDetailsQuery = formatStudentReportQuery(customId, reportDetailsQuery)
  let tempQuery = { vizState: {} }
  tempQuery.name = reportDetailsQuery?.reportName
  const dateFormat = handleDateFormatField(reportDetailsQuery?.dimensions)
  const columnDisplayName = handleColumnDisplayName(reportDetailsQuery)
  const fieldFormat = handleMeasureFieldFormat(reportDetailsQuery?.measures)
  let reportFilters = handleReportFilters(reportDetailsQuery?.reportFilters)
  reportFilters = formatStaticDashboardFilter(reportFilters, reportDetailsQuery)

  tempQuery.report = reportDetailsQuery;

  tempQuery.vizState = {
    chartType: reportDetailsQuery?.chartType,
    query: {
      measures: handleReportFields(reportDetailsQuery?.measures),
      order: handleQueryOrderBy(reportDetailsQuery),
      dimensions: handleReportFields(reportDetailsQuery?.dimensions),
      limit: reportDetailsQuery?.limit,
      timezone: 'UTC',
      timeDimensions: reportDetailsQuery?.timeDimensions,
      filters: handleFilterNullValues(reportFilters),
      renewQuery: renewCache
    },
    pivotConfig: handlePivotConfigFormat(reportDetailsQuery?.pivotConfig),
    columnState: reportDetailsQuery?.columnState || [],
    isPivotEnabled: reportDetailsQuery?.isPivotEnabled,
    isLegendVisible: reportDetailsQuery?.isLegendVisible,
    legendPosition: reportDetailsQuery?.legendPosition,
    columnTitle: formatReportTitle(reportDetailsQuery) || (columnTitle?.length ? columnTitle : []),
    dateFieldFormat: dateFormat,
    columnDisplayName: columnDisplayName,
    fieldFormat: fieldFormat,
    noDataText: reportDetailsQuery?.noDataText,
    reportHyperlink: reportDetailsQuery?.reportHyperlink || [],
    settings: reportDetailsQuery?.settings,
    toggleToTable: reportDetailsQuery?.toggleToTable,
    isPublishedDashboardView: isPublishedDashboardView,
    reportName: reportDetailsQuery?.reportName,
    description: reportDetailsQuery?.description,
    fieldsKeyInfo: getReportFieldsKey(reportDetailsQuery),
    backgroundColor: reportDetailsQuery?.backgroundColor,
    rateChangeQuery: handleRateChangeQuery(reportDetailsQuery, renewCache),
    hiddenFields: getHiddenFields([...(reportDetailsQuery?.measures ?? []), ...(reportDetailsQuery?.dimensions ?? [])]),
    comparisonChartType: reportDetailsQuery?.comparisonChartType,
  }
  tempQuery.vizState.query.filters = tempQuery?.vizState?.query?.filters?.map((item) => {
    if (item.operator === 'set' || item.operator === 'notSet') {
      return { member: item.member, operator: item.operator }
    }
    if (item?.member && item?.operator && item?.values?.length > 0)
      return { member: item.member, operator: item.operator, values: item.values }
  })



  return tempQuery
}




export default MapResponseForQuery
